import {
	type CURRENCYCODETYPE,
	type CURRENCYCONFIGTYPE,
	type IMeta,
	type ITransactionDetailsRow,
	type IWalletProps,
	selectedBeneficiarySchema,
} from 'BreetHelpers';
import type { UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';

export type WITHDRAWREQUESTSTAGETYPE = 'withdraw-funds' | 'add-beneficiary' | 'withdraw-details' | 'manage-beneficiaries';

export const requestPaymentStageTitle: Record<WITHDRAWREQUESTSTAGETYPE, string> = {
	'withdraw-funds': 'Withdraw Funds',
	'add-beneficiary': 'Add Bank Account',
	'withdraw-details': 'Withdrawal Confirmation',
	'manage-beneficiaries': 'Manage Accounts',
};

export interface IWithdrawFormComponent {
	onNext: () => void;
	onAddNewBeneficiary: () => void;
	currencyProps: CURRENCYCONFIGTYPE | undefined;
	userWalletProps: IWalletProps;
	onManageBeneficiaries: () => void;
	meta?: IMeta;
	withdrawRequestHookForm: UseFormReturn<CreateWithdrawRequestFormSchemaType>;
}

export const CreateWithdrawRequestFormSchema = yup.object({
	amount: yup.string().required('Amount details required'),
	selectedBeneficiary: selectedBeneficiarySchema,
	narration: yup.string().default(''),
});

export type CreateWithdrawRequestFormSchemaType = yup.InferType<typeof CreateWithdrawRequestFormSchema>;

export interface ITransactionDetails {
	content: ITransactionDetailsRow[];
	balance: string;
	withdrawalFee: string;
	narration: string;
	code: CURRENCYCODETYPE;
	totalDeducted: string;
	isInsufficientFunds: boolean;
	withdrawFunds: () => void;
}
